const t=t=>{try{return Buffer.from(t,"base64").toString("utf8")}catch(r){try{return btoa(t)}catch(t){return null}}};export{t as default};
